<template>
  <div>
    <b-card header-tag="header" no-body v-if="!detalhes">
      <template #header>
        <header-sagres
          :titulo="edital.IdTipoEdital === 3 ? 'Nova função' : 'Novo cargo'"
          breakpoint="xl"
        />
      </template>
      <b-overlay :show="overlayCadastro">
        <CardFiltrosBusca
          :titulo="`Cadastro de ${
            edital.IdTipoEdital === 3 ? 'função' : 'cargo'
          }`"
        >
          <b-card-body>
            <b-container>
              <validation-observer
                ref="validationobserver"
                v-slot="{ handleSubmit }"
              >
                <b-form @submit.prevent="handleSubmit(cadastrarCargo)">
                  <b-row style="text-align: left">
                    <b-col cols="12" lg="6">
                      <b-overlay :show="overlayCargos">
                        <default-form-validation-provider
                          :label="
                            edital.IdTipoEdital === 3 ? 'Função' : 'Cargo'
                          "
                          v-slot="defaultState"
                        >
                          <multiselect
                            v-model="cargoSelecionado"
                            open-direction="bottom"
                            :state="defaultState.state"
                            :placeholder="`Selecione ${
                              edital.IdTipoEdital === 3
                                ? 'uma função'
                                : 'um cargo'
                            }`"
                            track-by="value"
                            :options="listaCargos"
                            :allow-empty="true"
                            label="text"
                            close-on-select
                            searchable
                            deselect-label=""
                            :show-labels="false"
                            @select="mostraDsNomenclatura"
                          />
                        </default-form-validation-provider>
                      </b-overlay>
                    </b-col>
                    <b-col cols="12" lg="6">
                      <default-form-validation-provider
                        :label="`Nome ${
                          edital.IdTipoEdital === 3
                            ? 'da função temporária'
                            : 'do cargo temporário'
                        }`"
                        v-slot="defaultState"
                        v-if="
                          cargoSelecionado.value === 0 ||
                          cargoSelecionado.value === -1 ||
                          (cargoSelecionado.value === -2 &&
                            (edital.IdTipoEdital === 2 ||
                              edital.IdTipoEdital === 3))
                        "
                      >
                        <b-form-input
                          :placeholder="`Digite o nome ${
                            edital.IdTipoEdital === 3
                              ? 'da função temporária'
                              : 'do cargo temporário'
                          }`"
                          :state="defaultState.state"
                          v-model="campos.dsNomenclatura"
                          :disabled="edital.IdTipoEdital === 2"
                        />
                      </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" lg="6">
                      <default-form-validation-provider
                        label="Especialidade"
                        v-slot="defaultState"
                        rules=""
                      >
                        <b-form-input
                          v-model="campos.especialidade"
                          :state="defaultState.state"
                          placeholder="Digite a especialidade"
                        />
                      </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" lg="6">
                      <default-form-validation-provider
                        label="Localidade"
                        v-slot="defaultState"
                        rules=""
                      >
                        <b-form-input
                          placeholder="Digite a localidade"
                          :state="defaultState.state"
                          v-model="campos.localidade"
                        />
                      </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" lg="6">
                      <default-form-validation-provider
                        label="Quantidade de vagas para Ampla Concorrência"
                        v-slot="defaultState"
                      >
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="campos.qtdVagasAmpla"
                          :state="defaultState.state"
                          placeholder="Digite o número de vagas para ampla concorrência"
                        />
                      </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" lg="6" v-if="edital.FlVagasPcd">
                      <default-form-validation-provider
                        label="Quantidade de vagas para PCDs"
                        v-slot="defaultState"
                      >
                        <b-form-input
                          v-model="campos.qtdVagasPcd"
                          :state="defaultState.state"
                          type="number"
                          min="0"
                          placeholder="Digite o número de vagas para PCDs"
                        />
                      </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" lg="6" v-if="edital.FlVagasCotas">
                      <default-form-validation-provider
                        label="Quantidade de vagas para cotas"
                        v-slot="defaultState"
                      >
                        <b-form-input
                          v-model="campos.qtdVagasCotas"
                          type="number"
                          min="0"
                          :state="defaultState.state"
                          placeholder="Digite o número de vagas para cotistas"
                        />
                      </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" lg="6">
                      <default-form-validation-provider
                        label="Valor de inscrição"
                        v-slot="defaultState"
                      >
                        <money
                          class="form-control"
                          v-model="campos.vlInscricaoAmpla"
                          :state="defaultState.state"
                          v-bind="vMoneyOptions"
                          :disabled="campos.qtdVagasAmpla == 0"
                        />
                      </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" lg="6">
                      <default-form-validation-provider
                        label="Remuneração inicial"
                        v-slot="defaultState"
                      >
                        <money
                          class="form-control"
                          v-model="campos.remuneracaoInicial"
                          :state="defaultState.state"
                          v-bind="vMoneyOptions"
                        />
                      </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" lg="12" class="text-right">
                      <b-button
                        type="submit"
                        variant="secondary"
                        size="sm"
                        class="mt-2"
                      >
                        Cadastrar</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-container>
          </b-card-body>
        </CardFiltrosBusca>
      </b-overlay>
    </b-card>
    <b-card header-tag="header" no-body>
      <template #header>
        <header-sagres
          :titulo="
            edital.IdTipoEdital === 3
              ? 'Funções Cadastradas'
              : 'Cargos Cadastrados'
          "
          breakpoint="xl"
        />
      </template>
      <b-card-body>
        <b-overlay>
          <b-table
            responsive
            :items="listaCargosEditais"
            :fields="fields"
            striped
            show-empty
            hover
            stacked="xl"
          >
            <template #cell(actions)="data">
              <b-button
                size="sm"
                @click="
                  alertaCargoRemove(
                    data.item.id_edital_cargo ||
                      data.item.IdCargoProcessoSeletivoNavigation
                        .IdCargoProcessoSeletivo,
                    data.item.IdCargoNavigation.DeNomenclaturaCargo ||
                      data.item.IdCargoProcessoSeletivoNavigation.DsNomenclatura
                  )
                "
                :disabled="detalhes"
                ><font-awesome-icon icon="trash"
              /></b-button>
            </template>
            <template #cell(show_details)="row">
              <b-link class="text-dark" @click="row.toggleDetails">
                <font-awesome-icon
                  :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'"
                />
              </b-link>
            </template>
            <template #row-details="row">
              <b-card>
                <b-row class="mt-2">
                  <b-col cols="12" lg="4"
                    ><strong>Número de vagas Ampla Concorrência:</strong
                    ><span> {{ row.item.qtd_vagas_ampla }}</span></b-col
                  >
                  <b-col cols="12" lg="4"
                    ><strong>Número de vagas PCDs:</strong
                    ><span> {{ row.item.qtd_vagas_pcd }}</span></b-col
                  >

                  <b-col cols="12" lg="4"
                    ><strong>Número de vagas cotas:</strong
                    ><span> {{ row.item.qtd_vagas_cotas }}</span></b-col
                  >
                </b-row>
                <b-row class="mt-2">
                  <b-col cols="12" lg="4"
                    ><strong
                      >Valor inscrição de vagas Ampla Concorrência:</strong
                    ><span>
                      {{
                        row.item.vl_inscricao_ampla === 0
                          ? " R$ 0,00"
                          : formatMoeda(row.item.vl_inscricao_ampla)
                      }}</span
                    ></b-col
                  >
                </b-row>
              </b-card>
            </template>
            <template #cell(remuneracao_inicial)="data">
              <span>{{
                data.item.remuneracao_inicial === 0
                  ? " R$ 0,00"
                  : formatMoeda(data.item.remuneracao_inicial)
              }}</span>
            </template>
            <template #empty>
              <div class="text-center text-muted">Nenhum cargo cadastrado.</div>
            </template>
          </b-table>
        </b-overlay>
      </b-card-body>
    </b-card>
  </div>
</template>

<script lang="ts">
import { Money } from "v-money";
import { UtilsTS } from "@/utilsts";
import Multiselect from "vue-multiselect";
import { mixins } from "vue-class-component";
import { TableField } from "@/types/table-field";
import { ValidationObserver } from "vee-validate";
import { SelectValue } from "@/types/select-value";
import { CargoResumido } from "@/types/atos-pessoal/cargos/cargo-resumido";
import { Component, Ref, Vue } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import concursoService from "@/services/atos-pessoal/concursoService";
import { EditalConcurso } from "@/types/atos-pessoal/concursos/edital";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import { EditalCargo } from "@/types/atos-pessoal/concursos/edital-cargo";
import { fieldsCargos } from "@/types/atos-pessoal/concursos/fields-cargos";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { CargoEnvio } from "@/types/atos-pessoal/concursos/cargo-envio";

const CompProps = Vue.extend({
  name: "AbaCargosConcurso",
  components: {
    Money,
    Multiselect,
    HeaderSagres,
    CardFiltrosBusca,
    ValidationObserver,
    DefaultFormValidationProvider,
  },
  props: {
    idEdital: {
      type: Number,
      required: true,
    },
    detalhes: {
      type: Boolean,
      default: false,
    },
  },
});

@Component
export default class AbaCargosConcurso extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  campos: CargoEnvio = {
    idCargo: null,
    qtdVagasAmpla: 0,
    qtdVagasPcd: 0,
    qtdVagasCotas: 0,
    remuneracaoInicial: 0,
    localidade: "",
    especialidade: "",
    vlInscricaoAmpla: 0,
    dsNomenclatura: "",
  };

  edital: EditalConcurso = new EditalConcurso();

  cargoSelecionado: SelectValue = { text: "Selecione um Cargo", value: null };
  listaCargos: SelectValue[] = [];
  listaCargosEditais: EditalCargo[] = [];

  fields: TableField[] = fieldsCargos;

  //overlays
  overlayCadastro = false;
  overlayTabela = false;
  overlayCargos = false;

  async mounted() {
    await this.getConcursoById();
    await this.carregarCargos();
    await this.carregarCargosEdital();
  }

  async carregarCargos() {
    try {
      this.overlayCargos = true;
      const response =
        this.edital.IdTipoEdital === 2
          ? [
              {
                Id: -1,
                Codigo: "1",
                Nomenclatura: "Agente de Combate a Endemias",
              },
              {
                Id: -2,
                Codigo: "2",
                Nomenclatura: "Agente Comunitário de Saúde",
              },
            ]
          : await concursoService.listarCargos();
      if (response === null || response === undefined)
        return this.$toast.error("Erro ao obter a lista de cargos");
      this.listaCargos = response.map((b: CargoResumido) => ({
        value: b.Id,
        text: `${b.Codigo} - ${b.Nomenclatura}`,
      }));
      if (this.edital.IdTipoEdital === 3)
        this.listaCargos.unshift({ text: "Criar cargo temporário", value: 0 });
      this.listaCargos.unshift({ text: "Selecione uma opção", value: null });
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayCargos = false;
    }
  }

  async carregarCargosEdital() {
    try {
      this.overlayTabela = true;
      const response = await concursoService.listarCargosEdital(this.idEdital);
      this.listaCargosEditais = response;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayTabela = false;
    }
  }

  mostraDsNomenclatura() {
    (this.edital.IdTipoEdital === 2 && this.cargoSelecionado.value === -1) ||
    this.cargoSelecionado.value === -2
      ? (this.campos.dsNomenclatura = this.cargoSelecionado.text
          .split("-")[1]
          .trim())
      : (this.campos.dsNomenclatura = "");
  }

  async cadastrarCargo() {
    const isValid = await this.validationobserver.validate();
    if (!isValid) {
      this.$toast.error("Preencher campos obrigatórios (*)");
      console.error(this.validationobserver);
      return;
    }
    if (
      this.cargoSelecionado.value === null ||
      this.cargoSelecionado.value === undefined
    ) {
      this.$toast.error("Selecione um cargo ou função");
      return;
    }
    try {
      this.overlayCadastro = true;
      this.campos.idCargo = Number(this.cargoSelecionado.value);
      if (
        this.edital.IdTipoEdital === 2 &&
        (this.cargoSelecionado.value === -1 ||
          this.cargoSelecionado.value === -2)
      ) {
        this.campos.dsNomenclatura = this.cargoSelecionado.text
          .split("-")[1]
          .trim();
        this.campos.idCargo = 0;
      }
      await concursoService.adicionarCargosEdital(this.idEdital, this.campos);
      this.$toast.success(`Cargo adicionado ao edital com sucesso!`);
      this.campos = {
        idCargo: null,
        qtdVagasAmpla: 0,
        qtdVagasPcd: 0,
        qtdVagasCotas: 0,
        remuneracaoInicial: 0,
        localidade: "",
        especialidade: "",
        vlInscricaoAmpla: 0,
      };
      this.$emit("atualizarEdital");
      this.cargoSelecionado = this.listaCargos[0];
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.carregarCargosEdital();
      this.overlayCadastro = false;
    }
  }

  async excluirCargoEdital(idCargoEdital: number) {
    try {
      this.overlayTabela = true;
      await concursoService.excluirCargoEdital(idCargoEdital);
      this.$toast.success(`Cargo removido com sucesso!`);
      this.listaCargosEditais = this.listaCargosEditais.filter(
        (a: EditalCargo) => a.id_edital_cargo !== idCargoEdital
      );
      this.$emit("atualizarEdital");
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayTabela = false;
    }
  }

  alertaCargoRemove(idCargoEdital: number, nomeCargo: string) {
    if (this.detalhes) return;
    this.$bvModal
      .msgBoxConfirm(`Deseja remover o cargo de ${nomeCargo}?`, {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        okVariant: "secondary",
        title: "Remover cargo",
      })
      .then((value) => {
        if (value) this.excluirCargoEdital(idCargoEdital);
      })
      .catch((error) => {
        console.error(
          `Erro ao operar o dialogo de alerta de remoção de cargo`,
          error
        );
      });
  }

  async getConcursoById() {
    try {
      const response = await concursoService.getConcursoById(this.idEdital);
      if (!response) return this.$toast.error("Erro ao encontrar edital");
      this.edital = new EditalConcurso(response);
      if (this.edital.IdTipoEdital === 3)
        this.cargoSelecionado = { text: "Selecione uma Função", value: null };
    } catch (error: any) {
      this.tratarError(error);
    }
  }
}
</script>
